import { axiosApi } from 'app/api/api';
import { TableLinkData } from 'entities/table/model/tableLinkModel';

export const tableLinksApi = {
  fetch: async (id: string) => {
    const res = await axiosApi.get<TableLinkData>(`/link/${id}`);

    return res.data;
  },
};
